import React, { useState } from "react"
import { countryFlagEmoji, countryFlagUrl, isCountryCode } from "../data/countries"

export default function CountryFlag({ code, size = 20, className = "", label = "" }) {
  const [failed, setFailed] = useState(false)
  if (!isCountryCode(code)) return null

  const emoji = countryFlagEmoji(code)
  const assetWidth = size >= 36 ? 80 : 40
  const asset2x = size >= 36 ? 160 : 80
  if (failed) {
    return (
      <span
        className={`country-flag country-flag--emoji ${className}`.trim()}
        aria-hidden={!label}
        title={label || undefined}
        style={{ width: size, height: size, fontSize: `${Math.round(size * 0.72)}px` }}
      >
        {emoji}
      </span>
    )
  }

  return (
    <img
      className={`country-flag ${className}`.trim()}
      src={countryFlagUrl(code, assetWidth)}
      srcSet={`${countryFlagUrl(code, asset2x)} 2x`}
      alt={label}
      title={label || undefined}
      width={size}
      height={size}
      loading="lazy"
      decoding="async"
      onError={() => setFailed(true)}
    />
  )
}
